// extracted by mini-css-extract-plugin
module.exports = {"box":"box--mhVCy","products":"products--GLB12","list":"list--ZwMXN","info":"info--tB3YK","onlyHeight":"onlyHeight--dAsbt","onlyLink":"onlyLink--VJC8q"};